import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import Routes from './routes';
import AuthProvider from './providers/authProvider';
import { userManager } from './services/authService';
import store from './redux/store';
import { storeUserLanguage } from './redux/actions/globalizationAction';
import './styles/global.scss';
import getDataTermAndTranslationsByTag from './utils/globalization';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

function App() {
  const user = useSelector(state => state.auth.user);
  const translationsCache = useSelector(state => state.globalization.translationsCache);
  const lastCacheTime = useSelector(state => state.globalization.lastCacheTime);
  const currentUserLanguage = localStorage.getItem('userLanguage');

  useEffect(() => {
    // Define o idioma inicial da aplicação
    if (currentUserLanguage === null) {
      // TODO: Voltar com o comentado quando disponibilizar os outros idiomas
      localStorage.setItem('userLanguage', 'en-US');
      // localStorage.setItem('userLanguage', navigator.userLanguage || navigator.language);
    }

    store.dispatch(storeUserLanguage(currentUserLanguage));
  }, []);

  useEffect(() => {
    if (user) {
      getDataTermAndTranslationsByTag(currentUserLanguage, translationsCache, lastCacheTime);
    }
  }, [user]);

  return (
    <AuthProvider userManager={userManager} store={store}>
      <div className="app__container">
        <Routes />
      </div>
    </AuthProvider>
  );
}

export default App;
